module.exports = __webpack_public_path__ + "img/pr-7.cc959b45.png";